import { render, staticRenderFns } from "./LunchMenuPrivacy.vue?vue&type=template&id=4f9b2d4f&"
import script from "./LunchMenuPrivacy.vue?vue&type=script&lang=js&"
export * from "./LunchMenuPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./LunchMenuPrivacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports